import { useEffect, useRef } from 'react';

import { getOpParams } from '../getOpParams';

import { useIdentityAndUser } from './useIdentityAndUser';

declare let pendo: any;

/**
 * This hook waits for the current user info and then initializes Pendo Analytics
 * @see {@link https://support.pendo.io/hc/en-us/articles/360031862272-Install-Pendo-on-a-single-page-web-application}
 */
export const usePendoAnalytics = () => {
  const { orgId } = getOpParams();
  const { userId, identityId, user } = useIdentityAndUser();

  const initialized = useRef(false);

  useEffect(() => {
    if (identityId && typeof pendo !== 'undefined') {
      const config = {
        visitor: {
          id: identityId,
          user_id: userId,
          roles: user?.roles?.map(({ id }) => id).join(),
        },
        account: { id: orgId },
      };

      if (initialized.current) pendo.identify(config);
      else pendo.initialize(config);

      initialized.current = true;
    }
  }, [identityId, orgId, user?.roles, userId]);
};
